import { useState } from 'react';
import { Button } from '@repo/ui/Button';
import MessageBodyModal from './MessageBodyModal';

import type { Mercury } from '@repo/types/Models';

export interface MessageBodyCellProps {
  sms: Mercury.Models.SMS;
}

const MessageBodyCell = ({ sms }: MessageBodyCellProps) => {
  const [isOpenMessageBodyModal, setIsOpenMessageBodyModal] = useState<boolean>(false);
  return (
    <>
      <Button
        size="sm"
        variant="secondary"
        icon="visibility"
        onClick={() => setIsOpenMessageBodyModal(true)}
      >
        View body
      </Button>
      <MessageBodyModal
        isOpen={isOpenMessageBodyModal}
        setIsOpen={setIsOpenMessageBodyModal}
        sms={sms}
      />
    </>
  );
};

export default MessageBodyCell;
